import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useTranslation } from "react-i18next";

function Logout() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const patientID = localStorage.getItem("patientID");
  const kinkeeperID = localStorage.getItem("kinkeeperID");

  if (!patientID && !kinkeeperID) return null;

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("patientID");
    localStorage.removeItem("kinkeeperID");
    localStorage.removeItem("profileComplete");
    localStorage.removeItem("registrationSource");
    navigate("/");
  };

  return (
    <button className="topbar-logout" onClick={handleLogout} type="button">
      <span style={{ display: "inline-flex", alignItems: "center" }}>
        <LogOut color="white" size={18} />
      </span>
      <span className="topbar-logout-text">{t("nav.logout")}</span>
    </button>
  );
}

export default Logout;
